// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3GjYC","footer":"ReportModalFilter_footer__1hH2g"};